import React from "react"

import { ContentCopy } from "../ContentCopy"

import Styles from "./quote.module.scss"

export const Quote = props => {
  const { data } = props
  return (
    <div className={Styles.quoteWrapper}>
      {/* <IconQuotes role="presentation" /> */}
      <div className={Styles.quoteIcon}>“</div>
      <ContentCopy noMd extraStyles={Styles.quote} {...{ data }} />
    </div>
  )
}

export default Quote
